import React from 'react'
import { BaseCreating } from '../Create/Creating'

export function Joining() {
  return <BaseCreating />
}
